/* eslint-disable max-len */
import { Component, Host, h, Prop, Method, Element } from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

/**
 * @slot default - Content of the tab-panel
 */

@Component({
  tag: 'ui-tab-panel',
  styleUrl: 'ui-tab-panel.scss',
  shadow: true,
})
export class UiTabPanel {
  @Element() el: HTMLElement;

  /**
   * Tab panel's identification number
   */
  @Prop({ reflect: true }) tabPanelId: number;

  /**
   * Checks whether the panel is being used or not. The default value is *false*. When set to true, the panel appears, when set to false it is not displayed.
   */
  @Prop({ reflect: true, mutable: true }) active = false;

  /**
   * Method triggered when tab panel is selected
   */
  @Method()
  async activate() {
    this.active = true;
  }

  /**
   * Method triggered when tab panel is deselected
   */
  @Method()
  async deactivate() {
    this.active = false;
  }

  render() {
    return (
      <Host
        class={{
          active: this.active,
        }}
        aria-labelledby={this.tabPanelId}
      >
        <slot></slot>
      </Host>
    );
  }
}

versionComponent(UiTabPanel);
